import { render, staticRenderFns } from "./telegram-bot.vue?vue&type=template&id=515604bc&"
import script from "./telegram-bot.vue?vue&type=script&lang=js&"
export * from "./telegram-bot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports